import { AxiosError } from "axios";
import { type AppInsights } from "./appinsights-loadable";

let appInsightsModule: AppInsights;
let isLoading = false;
let isLoaded = false;

// Promise for module loading
let loadPromise: Promise<void> | null = null;

export const appInsights: AppInsights = {
  initAppInsights: function () {
    // console.log("Running init 1", process.env.NEXT_RUNTIME);

    loadAppinsights().then(() => {
      // console.log("Running init 2", process.env.NEXT_RUNTIME);
      appInsightsModule.initAppInsights();
    });
  },

  trackBackendError: function (error: AxiosError | Error, methodName?: string) {
    // console.log("Running track 1");

    loadAppinsights().then(() => {
      // console.log("Running track 2", process.env.NEXT_RUNTIME);
      appInsightsModule.trackBackendError(error, methodName);
    });
  }
};

export function loadAppinsights(): Promise<void> {
  if (isLoaded) {
    return Promise.resolve();
  }

  if (!loadPromise) {
    loadPromise = loadAppInsightsInternal();
  }

  return loadPromise;
}

async function loadAppInsightsInternal(): Promise<void> {
  if (isLoading || isLoaded) {
    return;
  }

  isLoading = true;

  if (process.env.NEXT_RUNTIME === "nodejs" && process.env.SERVER_APPINSIGHTS === "true") {
    // console.log("Loading appinsights", process.env.NEXT_RUNTIME);
    appInsightsModule = (await import("./appinsights-loadable")).default;

    appInsightsModule.initAppInsights();

    isLoaded = true;
  }

  isLoading = false;
}
